import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Modal from 'app/components/Modal';

const VideoModal = props => {
  const {
    open,
    src,
    onClose,
  } = props;

  const videoStyle = {
    height: "100%",
    width: "100%" 
  }

  const boxStyle = {
    height: "100%",
    width: "100%" 
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row-reverse"
      >
        <video style={videoStyle} controls>
            <source src={src} type="video/mp4" />
        </video>
      </Box>
    </Modal>
  );
}

export default VideoModal;
